<template>
  <div>
    <div class="mb-4">
      <p v-if="!orderFound && !submitted">
        Enter your order ID to see if your order is eligible to be edited.
      </p>
      <p v-else-if="submitted">
        <template v-if="eligibilityMessage === 'Sorry, we were unable to find an order matching that ID. Please try again.' && project() === 'kitlocker-main-site-364199'">
          Sorry, we were unable to find an order matching that ID. Try <a href="https://myorders.kitlocker.shop/login/">https://myorders.kitlocker.shop/login/</a>.
        </template>
        <template v-else>
          {{ eligibilityMessage }}
        </template>
      </p>
    </div>
    <tml-form ref="findOrderForm" form-name="find-order-form">
      <div v-if="!submitted">
        <tml-input
          v-model="orderId"
          :validation-rules="{required: true}"
          placeholder="Order ID (e.g. 123123)"
          field-name="orderId"
          type="text"
          @submit="onSubmit"
        />
        <tml-button fill text="Submit" :loading="loading" @click="onSubmit" />
      </div>
    </tml-form>
    <tml-form ref="editOrderForm" form-name="edit-order-form">
      <div v-if="submitted && canEdit">
        <tml-input
          v-model="emailAddress"
          :validation-rules="{required: true, email: true}"
          placeholder="Email address"
          field-name="emailAddress"
          type="email"
        />
        <tml-input
          v-if="confirmZip"
          v-model="zip"
          :validation-rules="{required: true}"
          placeholder="Postcode / zip"
          field-name="zip"
        />
        <tml-re-captcha
          ref="captcha"
          :class="{'mb-4': recaptchaMargin}"
          action="subdomains/editOrder"
          @rendered="recaptchaMargin = true"
        />
        <tml-button
          fill
          text="Edit order"
          :loading="loading"
          @click="editOrder"
        />
      </div>
    </tml-form>
  </div>
</template>

<script>
import {formatUrl} from '@teemill/common/helpers';

export default {
  name: 'HelpEditOrder',

  data() {
    return {
      zip: null,
      orderId: null,
      canEdit: null,
      loading: false,
      orderFound: null,
      submitted: false,
      confirmZip: false,
      emailAddress: null,
      recaptchaMargin: false,
      eligibilityMessage: '',
    };
  },

  methods: {
    onSubmit() {
      this.$refs.findOrderForm.validateAll().then(success => {
        if (success) {
          this.loading = true;

          this.axios
            .post(formatUrl('/omnis/v3/contact/edit-order-eligibility/'), {
              orderId: this.orderId,
            })
            .success(data => {
              if (data) {
                this.submitted = true;
                this.orderFound = data.orderFound;
                this.confirmZip = data.confirmZip;
                this.canEdit = data.canEdit;
                this.eligibilityMessage = data.message;
              }
            })
            .validation(message => {
              if (message) {
                snackbar.error(message);
              }
            })
            .oops()
            .any(() => {
              if (this.$refs.captcha) {
                this.$refs.captcha.recaptcha.reload();
              }
            })
            .finally(() => {
              this.loading = false;
            });
        }
      });
    },

    editOrder() {
      this.$refs.editOrderForm.validateAll().then(success => {
        if (success) {
          this.loading = true;

          this.$refs.captcha.recaptcha
            .ifHuman(recaptcha => {
              this.axios
                .post(
                  formatUrl(
                    `/omnis/v3/frontend/retex/get-order-hash/${this.orderId}`
                  ),
                  {
                    zip: this.zip,
                    emailAddress: this.emailAddress,
                    v3captchaToken: recaptcha.v3Token,
                    v2captchaToken: recaptcha.v2Token,
                  }
                )
                .then(({data}) => {
                  this.loading = false;
                  this.$router.push({path: `/edit-order/${data}/`});
                })
                .catch(({response}) => {
                  if (response && response.data && response.data.message) {
                    this.showErrorSnackBar(response.data.message);
                  } else {
                    this.showErrorSnackBar();
                  }

                  this.loading = false;
                });
            })
            .ifBot(() => {
              this.loading = false;
            });
        }
      });
    },

    showErrorSnackBar(message) {
      this.$dialogs.showSnackBar({
        type: 'error',
        message:
          message ||
          'Oops... looks like something went wrong. Please try again.',
      });
    },

    project() {
      return (
        this.$project?.active?.id || this.$store.state.subdomain?.project?.id
      );
    },
  },
};
</script>
